// extracted by mini-css-extract-plugin
export default {"decline-event-button":"styles_decline-event-button__mPpfQ"};